/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterPageAddPost } from '../fn/page/api-master-page-add-post';
import { ApiMasterPageAddPost$Params } from '../fn/page/api-master-page-add-post';
import { apiMasterPageApproveRejectPost } from '../fn/page/api-master-page-approve-reject-post';
import { ApiMasterPageApproveRejectPost$Params } from '../fn/page/api-master-page-approve-reject-post';
import { apiMasterPageDeleteGet } from '../fn/page/api-master-page-delete-get';
import { ApiMasterPageDeleteGet$Params } from '../fn/page/api-master-page-delete-get';
import { apiMasterPageEditPost } from '../fn/page/api-master-page-edit-post';
import { ApiMasterPageEditPost$Params } from '../fn/page/api-master-page-edit-post';
import { apiMasterPageGetActiveGet } from '../fn/page/api-master-page-get-active-get';
import { ApiMasterPageGetActiveGet$Params } from '../fn/page/api-master-page-get-active-get';
import { apiMasterPageGetAllGet } from '../fn/page/api-master-page-get-all-get';
import { ApiMasterPageGetAllGet$Params } from '../fn/page/api-master-page-get-all-get';
import { apiMasterPageGetByCriteriaPost } from '../fn/page/api-master-page-get-by-criteria-post';
import { ApiMasterPageGetByCriteriaPost$Params } from '../fn/page/api-master-page-get-by-criteria-post';
import { apiMasterPageGetPageByMenuGet } from '../fn/page/api-master-page-get-page-by-menu-get';
import { ApiMasterPageGetPageByMenuGet$Params } from '../fn/page/api-master-page-get-page-by-menu-get';
import { apiMasterPageGetPageByMenuIdGet } from '../fn/page/api-master-page-get-page-by-menu-id-get';
import { ApiMasterPageGetPageByMenuIdGet$Params } from '../fn/page/api-master-page-get-page-by-menu-id-get';
import { apiMasterPageGetPageBySubMenuIdGet } from '../fn/page/api-master-page-get-page-by-sub-menu-id-get';
import { ApiMasterPageGetPageBySubMenuIdGet$Params } from '../fn/page/api-master-page-get-page-by-sub-menu-id-get';
import { Page } from '../models/page';
import { PageApiRespModel } from '../models/page-api-resp-model';
import { StringApiRespModel } from '../models/string-api-resp-model';

@Injectable({ providedIn: 'root' })
export class PageService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterPageAddPost()` */
  static readonly ApiMasterPageAddPostPath = '/api/Master/Page/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterPageAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterPageAddPost$Response(params?: ApiMasterPageAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<PageApiRespModel>> {
    return apiMasterPageAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterPageAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterPageAddPost(params?: ApiMasterPageAddPost$Params, context?: HttpContext): Observable<PageApiRespModel> {
    return this.apiMasterPageAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageApiRespModel>): PageApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterPageEditPost()` */
  static readonly ApiMasterPageEditPostPath = '/api/Master/Page/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterPageEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterPageEditPost$Response(params?: ApiMasterPageEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<PageApiRespModel>> {
    return apiMasterPageEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterPageEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterPageEditPost(params?: ApiMasterPageEditPost$Params, context?: HttpContext): Observable<PageApiRespModel> {
    return this.apiMasterPageEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageApiRespModel>): PageApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterPageApproveRejectPost()` */
  static readonly ApiMasterPageApproveRejectPostPath = '/api/Master/Page/ApproveReject';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterPageApproveRejectPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterPageApproveRejectPost$Response(params?: ApiMasterPageApproveRejectPost$Params, context?: HttpContext): Observable<StrictHttpResponse<PageApiRespModel>> {
    return apiMasterPageApproveRejectPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterPageApproveRejectPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterPageApproveRejectPost(params?: ApiMasterPageApproveRejectPost$Params, context?: HttpContext): Observable<PageApiRespModel> {
    return this.apiMasterPageApproveRejectPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageApiRespModel>): PageApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterPageDeleteGet()` */
  static readonly ApiMasterPageDeleteGetPath = '/api/Master/Page/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterPageDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterPageDeleteGet$Response(params?: ApiMasterPageDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StringApiRespModel>> {
    return apiMasterPageDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterPageDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterPageDeleteGet(params?: ApiMasterPageDeleteGet$Params, context?: HttpContext): Observable<StringApiRespModel> {
    return this.apiMasterPageDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringApiRespModel>): StringApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterPageGetAllGet()` */
  static readonly ApiMasterPageGetAllGetPath = '/api/Master/Page/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterPageGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterPageGetAllGet$Response(params?: ApiMasterPageGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Page>>> {
    return apiMasterPageGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterPageGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterPageGetAllGet(params?: ApiMasterPageGetAllGet$Params, context?: HttpContext): Observable<Array<Page>> {
    return this.apiMasterPageGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Page>>): Array<Page> => r.body)
    );
  }

  /** Path part for operation `apiMasterPageGetPageByMenuIdGet()` */
  static readonly ApiMasterPageGetPageByMenuIdGetPath = '/api/Master/Page/GetPageByMenuId';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterPageGetPageByMenuIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterPageGetPageByMenuIdGet$Response(params?: ApiMasterPageGetPageByMenuIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Page>> {
    return apiMasterPageGetPageByMenuIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterPageGetPageByMenuIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterPageGetPageByMenuIdGet(params?: ApiMasterPageGetPageByMenuIdGet$Params, context?: HttpContext): Observable<Page> {
    return this.apiMasterPageGetPageByMenuIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Page>): Page => r.body)
    );
  }

  /** Path part for operation `apiMasterPageGetPageBySubMenuIdGet()` */
  static readonly ApiMasterPageGetPageBySubMenuIdGetPath = '/api/Master/Page/GetPageBySubMenuId';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterPageGetPageBySubMenuIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterPageGetPageBySubMenuIdGet$Response(params?: ApiMasterPageGetPageBySubMenuIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Page>> {
    return apiMasterPageGetPageBySubMenuIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterPageGetPageBySubMenuIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterPageGetPageBySubMenuIdGet(params?: ApiMasterPageGetPageBySubMenuIdGet$Params, context?: HttpContext): Observable<Page> {
    return this.apiMasterPageGetPageBySubMenuIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Page>): Page => r.body)
    );
  }

  /** Path part for operation `apiMasterPageGetPageByMenuGet()` */
  static readonly ApiMasterPageGetPageByMenuGetPath = '/api/Master/Page/GetPageByMenu';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterPageGetPageByMenuGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterPageGetPageByMenuGet$Response(params?: ApiMasterPageGetPageByMenuGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Page>> {
    return apiMasterPageGetPageByMenuGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterPageGetPageByMenuGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterPageGetPageByMenuGet(params?: ApiMasterPageGetPageByMenuGet$Params, context?: HttpContext): Observable<Page> {
    return this.apiMasterPageGetPageByMenuGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Page>): Page => r.body)
    );
  }

  /** Path part for operation `apiMasterPageGetActiveGet()` */
  static readonly ApiMasterPageGetActiveGetPath = '/api/Master/Page/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterPageGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterPageGetActiveGet$Response(params?: ApiMasterPageGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Page>>> {
    return apiMasterPageGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterPageGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterPageGetActiveGet(params?: ApiMasterPageGetActiveGet$Params, context?: HttpContext): Observable<Array<Page>> {
    return this.apiMasterPageGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Page>>): Array<Page> => r.body)
    );
  }

  /** Path part for operation `apiMasterPageGetByCriteriaPost()` */
  static readonly ApiMasterPageGetByCriteriaPostPath = '/api/Master/Page/GetByCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterPageGetByCriteriaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterPageGetByCriteriaPost$Response(params?: ApiMasterPageGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Page>>> {
    return apiMasterPageGetByCriteriaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterPageGetByCriteriaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterPageGetByCriteriaPost(params?: ApiMasterPageGetByCriteriaPost$Params, context?: HttpContext): Observable<Array<Page>> {
    return this.apiMasterPageGetByCriteriaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Page>>): Array<Page> => r.body)
    );
  }

}
